/* RunwayRugs – Custom Rugs & Portfolio (Preisrechner, Anfrage, Galerie, Video). Keine Abhängigkeiten. */
(() => {
  if (window.__rrInit) return;
  window.__rrInit = true;

  const num = (v, d) => { const n = parseFloat(v); return Number.isFinite(n) ? n : d; };
  const eur = (n) => new Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 }).format(n);
  const store = {
    get(k) { try { return JSON.parse(sessionStorage.getItem(k) || 'null'); } catch (e) { return null; } },
    set(k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} },
    del(k) { try { sessionStorage.removeItem(k); } catch (e) {} }
  };

  /* ---------------- Preisrechner ----------------
     Mitte = Grundpauschale + Fläche(m²) × (m²-Preis + Farbzuschlag × max(0, Farben − inkl.)) × Komplexität × Form
     Rund: echte Kreisfläche. Freie Form: Breite × Höhe × Füllgrad (Näherung).
     Alle Werte kommen aus den Section-Einstellungen (data-*). */
  if (!customElements.get('rr-calculator')) {
    customElements.define('rr-calculator', class extends HTMLElement {
      connectedCallback() {
        const d = this.dataset;
        this.cfg = {
          base: num(d.base, 100), rate: num(d.rate, 480), colorFee: num(d.colorFee, 60), incl: num(d.colorsIncluded, 3),
          cx: { simple: num(d.cxSimple, 85) / 100, medium: num(d.cxMedium, 100) / 100, complex: num(d.cxComplex, 130) / 100 },
          shape: { rect: 1, round: num(d.shapeRound, 110) / 100, free: num(d.shapeFree, 120) / 100 },
          fill: num(d.freeFill, 80) / 100, low: num(d.spreadLow, 8) / 100, high: num(d.spreadHigh, 8) / 100,
          roundTo: Math.max(1, num(d.roundTo, 10)), minPrice: num(d.minPrice, 0),
          min: num(d.min, 30), maxLong: num(d.maxLong, 170), maxShort: num(d.maxShort, 120), maxRound: num(d.maxRound, 120)
        };
        this.wRange = this.querySelector('[data-dim="w"] input[type=range]');
        this.hRange = this.querySelector('[data-dim="h"] input[type=range]');
        this.wNum = this.querySelector('[data-for="w"]');
        this.hNum = this.querySelector('[data-for="h"]');
        this.hField = this.querySelector('[data-dim="h"]');
        this.wLabel = this.querySelector('[data-w-label]');
        this.limit = this.querySelector('[data-limit]');
        this.limitText = this.limit.textContent;
        this.colorsOut = this.querySelector('[data-colors]');
        this.colors = num(this.colorsOut.value || this.colorsOut.textContent, 5);
        this.maxColors = num(this.colorsOut.dataset.max, 15);

        this.wRange.addEventListener('input', () => this.setDim('w', this.wRange.value));
        this.hRange.addEventListener('input', () => this.setDim('h', this.hRange.value));
        this.wNum.addEventListener('change', () => this.setDim('w', this.wNum.value));
        this.hNum.addEventListener('change', () => this.setDim('h', this.hNum.value));
        this.querySelectorAll('input[type=radio]').forEach((r) => r.addEventListener('change', () => {
          if (r.name.startsWith('rr-shape')) this.setDim('w', this.wRange.value); else this.update();
        }));
        this.querySelectorAll('[data-step]').forEach((b) => b.addEventListener('click', () => {
          this.colors = Math.min(this.maxColors, Math.max(1, this.colors + num(b.dataset.step, 0)));
          this.update();
        }));
        this.querySelector('[data-apply]').addEventListener('click', (e) => this.apply(e));
        this.setDim('w', this.wRange.value);
      }

      get shape() { return (this.querySelector('input[name^="rr-shape"]:checked') || {}).value || 'rect'; }
      get cx() { return (this.querySelector('input[name^="rr-cx"]:checked') || {}).value || 'medium'; }
      label(prefix) { const el = this.querySelector(`input[name^="${prefix}"]:checked`); return el ? el.dataset.label : ''; }

      /* Größenlogik: kurze Seite ≤ maxShort, lange Seite ≤ maxLong. Rund: Durchmesser ≤ maxRound. */
      setDim(which, raw) {
        const c = this.cfg;
        const round = this.shape === 'round';
        let w = Math.round(num(which === 'w' ? raw : this.wRange.value, c.min));
        let h = Math.round(num(which === 'h' ? raw : this.hRange.value, c.min));
        let clamped = false;
        const maxW = round ? c.maxRound : c.maxLong;
        if (w > maxW) { w = maxW; clamped = true; }
        if (w < c.min) { w = c.min; clamped = true; }
        if (h > c.maxLong) { h = c.maxLong; clamped = true; }
        if (h < c.min) { h = c.min; clamped = true; }
        if (!round && w > c.maxShort && h > c.maxShort) {
          if (which === 'w') h = c.maxShort; else w = c.maxShort;
          clamped = true;
        }
        if (round) h = w;
        this.w = w; this.h = h;
        this.hField.hidden = round;
        this.wLabel.textContent = round ? 'Durchmesser' : 'Breite';
        this.wRange.max = maxW; this.wNum.max = maxW;
        this.sync(this.wRange, this.wNum, w);
        this.sync(this.hRange, this.hNum, h);
        this.limit.textContent = clamped
          ? `Maximal ${c.maxShort} × ${c.maxLong} cm${round ? `, rund bis ${c.maxRound} cm` : ''}. Größer gewünscht? Frag einfach an – Sondergrößen prüfe ich persönlich.`
          : this.limitText;
        this.limit.classList.toggle('rr-hint--warn', clamped);
        this.update();
      }

      sync(range, input, v) {
        range.value = v; input.value = v;
        const min = num(range.min, 0), max = num(range.max, 100);
        range.style.setProperty('--rr-fill', `${((v - min) / (max - min)) * 100}%`);
      }

      calc() {
        const c = this.cfg, s = this.shape;
        let area = (this.w * this.h) / 10000;
        if (s === 'round') area = Math.PI * Math.pow(this.w / 200, 2);
        if (s === 'free') area *= c.fill;
        const extra = Math.max(0, this.colors - c.incl);
        const mid = c.base + area * (c.rate + c.colorFee * extra) * (c.cx[this.cx] || 1) * (c.shape[s] || 1);
        const r = (n) => Math.round(n / c.roundTo) * c.roundTo;
        const low = Math.max(c.minPrice, r(mid * (1 - c.low)));
        const high = Math.max(low + c.roundTo, r(mid * (1 + c.high)));
        return { low, high, area };
      }

      update() {
        this.colorsOut.textContent = this.colors;
        this.colorsOut.value = this.colors;
        const { low, high } = this.calc();
        this.result = { low, high };
        this.priceText = `ca. ${eur(low)} – ${eur(high)} €`;
        this.querySelector('[data-price]').textContent = this.priceText;
        const s = this.shape;
        const dims = s === 'round' ? `Ø ${this.w} cm` : `${this.w} × ${this.h} cm`;
        this.querySelector('[data-summary]').textContent = `${this.label('rr-shape')} · ${dims} · ${this.label('rr-cx')} · ${this.colors} Farben`;
        this.querySelector('[data-free-hint]').hidden = s !== 'free';
        this.draw(dims);
      }

      draw(dims) {
        const g = this.querySelector('[data-shape]');
        const t = this.querySelector('[data-dims]');
        const max = this.cfg.maxLong, size = 176;
        const w = Math.max(24, (this.w / max) * size), h = Math.max(24, (this.h / max) * size);
        const x = 100 - w / 2, y = 100 - h / 2;
        const s = this.shape;
        if (s === 'round') g.innerHTML = `<ellipse cx="100" cy="100" rx="${w / 2}" ry="${w / 2}"/>`;
        else if (s === 'free') g.innerHTML = `<path d="M${x + w * .18} ${y + h * .08} C${x + w * .55} ${y - h * .04} ${x + w * 1.02} ${y + h * .12} ${x + w * .94} ${y + h * .48} C${x + w * .88} ${y + h * .8} ${x + w * .68} ${y + h * 1.02} ${x + w * .38} ${y + h * .94} C${x + w * .06} ${y + h * .86} ${x - w * .02} ${y + h * .55} ${x + w * .04} ${y + h * .32} C${x + w * .07} ${y + h * .2} ${x + w * .1} ${y + h * .12} ${x + w * .18} ${y + h * .08}Z"/>`;
        else g.innerHTML = `<rect x="${x}" y="${y}" width="${w}" height="${h}"/>`;
        t.textContent = dims;
      }

      apply(e) {
        const data = {
          width: this.w, height: this.shape === 'round' ? this.w : this.h,
          shape: this.label('rr-shape'), complexity: this.label('rr-cx'), colors: this.colors,
          price: `${this.priceText} (unverbindlich, ${this.shape === 'round' ? 'Ø ' + this.w + ' cm' : this.w + ' × ' + this.h + ' cm'})`
        };
        const target = document.querySelector(this.dataset.target);
        const form = target && target.querySelector('form[data-rr-form]');
        if (!form) return; // ohne Formular normal dem Link folgen
        e.preventDefault();
        fillForm(form, data, true);
        target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        const first = form.querySelector('input[name="contact[name]"]');
        if (first) setTimeout(() => first.focus({ preventScroll: true }), 450);
      }
    });
  }

  /* ---------------- Anfrageformular ---------------- */
  function fillForm(form, data, note) {
    Object.keys(data).forEach((k) => {
      const el = form.querySelector(`[data-calc="${k}"]`);
      if (!el) return;
      if (el.tagName === 'SELECT') {
        const opt = Array.from(el.options).find((o) => o.text.trim() === String(data[k]).trim());
        if (opt) el.value = opt.value || opt.text;
      } else el.value = data[k];
    });
    const pf = form.querySelector('[data-price-field]');
    if (pf && data.price) pf.hidden = false;
    const n = form.querySelector('[data-prefill-note]');
    if (n && note) n.classList.add('is-visible');
    saveForm(form);
  }

  const KEY = () => 'rr-inquiry:' + location.pathname;
  function saveForm(form) {
    const v = {};
    form.querySelectorAll('input, select, textarea').forEach((el) => {
      if (!el.name || el.type === 'hidden' || el.type === 'checkbox') return;
      v[el.name] = el.value;
    });
    store.set(KEY(), v);
  }

  function initForm(form) {
    if (form.querySelector('[data-rr-success]') || /contact_posted=true/.test(location.search)) {
      store.del(KEY());
      const ok = form.querySelector('[data-rr-success]');
      if (ok) ok.focus();
      return;
    }
    // gespeicherte Eingaben wiederherstellen (z. B. nach Captcha, Fehler oder Neuladen)
    const saved = store.get(KEY());
    if (saved) {
      Object.keys(saved).forEach((name) => {
        const el = form.querySelector(`[name="${CSS.escape(name)}"]`);
        if (el && !el.value && saved[name]) el.value = saved[name];
      });
      const price = form.querySelector('[data-calc="price"]');
      if (price && price.value) form.querySelector('[data-price-field]').hidden = false;
    }
    form.addEventListener('input', () => saveForm(form));

    form.noValidate = true; // eigene, verständliche Fehlermeldungen
    form.addEventListener('submit', (e) => {
      let firstBad = null;
      form.querySelectorAll('[required]').forEach((el) => {
        const err = document.getElementById((el.getAttribute('aria-describedby') || '').split(' ')[0]);
        const bad = el.type === 'checkbox' ? !el.checked : !el.value.trim() || (el.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(el.value.trim()));
        el.setAttribute('aria-invalid', bad ? 'true' : 'false');
        if (err) err.hidden = !bad;
        if (bad && !firstBad) firstBad = el;
      });
      if (firstBad) { e.preventDefault(); firstBad.focus(); return; }
      saveForm(form);
    });
  }

  /* ---------------- Video (2-Klick, lädt erst nach Klick) ---------------- */
  function initVideo(box) {
    const btn = box.querySelector('button');
    btn.addEventListener('click', () => {
      const f = document.createElement('iframe');
      f.src = box.dataset.rrVideo;
      f.title = btn.getAttribute('aria-label') || 'Video';
      f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      f.allowFullscreen = true;
      box.replaceChildren(f);
    });
  }

  /* ---------------- Portfolio: Filter + Lightbox ---------------- */
  function initGallery(list) {
    const root = list.closest('section');
    const dialog = root.querySelector('[data-rr-lightbox]');
    const filter = root.querySelector('[data-rr-filter]');
    if (filter) {
      filter.addEventListener('click', (e) => {
        const b = e.target.closest('button[data-filter]');
        if (!b) return;
        filter.querySelectorAll('button').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
        list.querySelectorAll('.rr-gallery__item').forEach((li) => { li.hidden = b.dataset.filter !== '*' && li.dataset.cat !== b.dataset.filter; });
      });
    }
    if (!dialog || typeof dialog.showModal !== 'function') return;
    const track = dialog.querySelector('[data-track]');
    const info = dialog.querySelector('[data-info-target]');
    const count = dialog.querySelector('[data-count]');
    const prev = dialog.querySelector('[data-prev]');
    const next = dialog.querySelector('[data-next]');
    let slides = 0, opener = null;

    const current = () => Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    const go = (i) => track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    const refresh = () => {
      const i = current();
      count.textContent = slides > 1 ? `${i + 1} / ${slides}` : '';
      prev.hidden = slides < 2 || i === 0;
      next.hidden = slides < 2 || i >= slides - 1;
    };

    const open = (handle, btn) => {
      const tpl = list.querySelector(`template[data-project="${CSS.escape(handle)}"]`);
      if (!tpl) return;
      const frag = tpl.content.cloneNode(true);
      track.replaceChildren(...frag.querySelector('[data-slides]').children);
      info.replaceChildren(...frag.querySelector('[data-info]').children);
      slides = track.children.length;
      opener = btn || null;
      dialog.showModal();
      track.scrollLeft = 0;
      refresh();
      dialog.querySelector('[data-close]').focus();
    };

    list.addEventListener('click', (e) => {
      const b = e.target.closest('[data-open]');
      if (b) open(b.dataset.open, b);
    });
    prev.addEventListener('click', () => go(current() - 1));
    next.addEventListener('click', () => go(current() + 1));
    track.addEventListener('scroll', () => requestAnimationFrame(refresh), { passive: true });
    dialog.querySelector('[data-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (e) => { if (e.target === dialog) dialog.close(); });
    dialog.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current() - 1); }
    });
    dialog.addEventListener('close', () => {
      track.replaceChildren(); info.replaceChildren();
      if (opener) setTimeout(() => opener.focus(), 0);
    });

    // Direktlink aus der Vorschau: /pages/portfolio#projekt-<handle>
    const m = location.hash.match(/^#projekt-(.+)$/);
    if (m) {
      const btn = list.querySelector(`[data-open="${CSS.escape(decodeURIComponent(m[1]))}"]`);
      if (btn) { btn.scrollIntoView({ block: 'center' }); open(btn.dataset.open, btn); }
    }
  }

  const init = (scope) => {
    scope.querySelectorAll('form[data-rr-form]:not([data-rr-ready])').forEach((f) => { f.dataset.rrReady = '1'; initForm(f); });
    scope.querySelectorAll('[data-rr-video]:not([data-rr-ready])').forEach((v) => { v.dataset.rrReady = '1'; initVideo(v); });
    scope.querySelectorAll('[data-rr-gallery]:not([data-rr-ready])').forEach((g) => { g.dataset.rrReady = '1'; initGallery(g); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
